import { orderIsFreeDutiesEligible } from "../../utils/orderIsFreeDutiesEligible";
import { TAXES_AND_FEES_ARE_NOT_COVERED_BY_FAIRE } from "./shared";
export var DutiesInvoiceIA = function DutiesInvoiceIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  var brandOrder = context.brandOrder;
  if (!brandOrder) {
    return ORDER_NOT_SELECTED(strictLocalize);
  }
  return orderIsFreeDutiesEligible(brandOrder) ? DUTIES_FREE_ORDER(strictLocalize) : NON_DUTIES_FREE_ORDER(strictLocalize);
};
var ORDER_NOT_SELECTED = function ORDER_NOT_SELECTED(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return DUTIES_INVOICES_WITH_FAIRE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ORDERS_WITH_DUTIES_ELIGIBLE_GOODS_GENERATE_DUTIES_INVOICE(strictLocalize), YOU_WILL_BE_RESPONSIBLE_FOR_DUTIES(strictLocalize), TAXES_AND_FEES_ARE_NOT_COVERED_BY_FAIRE(strictLocalize)];
    }
  };
};
var DUTIES_FREE_ORDER = function DUTIES_FREE_ORDER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return DUTIES_INVOICES_WITH_FAIRE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ORDER_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize), TAXES_AND_FEES_ARE_NOT_COVERED_BY_FAIRE(strictLocalize)];
    }
  };
};
var NON_DUTIES_FREE_ORDER = function NON_DUTIES_FREE_ORDER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return DUTIES_INVOICES_WITH_FAIRE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ORDER_NOT_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize), TAXES_AND_FEES_ARE_NOT_COVERED_BY_FAIRE(strictLocalize)];
    }
  };
};
var DUTIES_INVOICES_WITH_FAIRE = function DUTIES_INVOICES_WITH_FAIRE(strictLocalize) {
  return strictLocalize({
    id: "GUFPUU",
    defaultMessage: [{
      "type": 0,
      "value": "Factures pour les droits de douane avec Faire"
    }]
  });
};
var ORDERS_WITH_DUTIES_ELIGIBLE_GOODS_GENERATE_DUTIES_INVOICE = function ORDERS_WITH_DUTIES_ELIGIBLE_GOODS_GENERATE_DUTIES_INVOICE(strictLocalize) {
  return strictLocalize({
    id: "nV464S",
    defaultMessage: [{
      "type": 0,
      "value": "Une facture pour les droits de douane est créée dès qu'une commande inclut des produits sur lesquels des droits de douane s'appliquent. Si les droits de douane sont pris en charge pour votre commande, nous appliquerons lors du passage en caisse une remise correspondant au coût estimé des droits de douane pour votre commande. À l'expédition de la commande, le transporteur vous enverra une facture incluant tous les frais (y compris les droits de douane et la TVA), que vous paierez en totalité. Si les droits de douane sont pris en charge et que le coût réel des droits de douane et des frais de débours est supérieur à la remise qui vous a été accordée sur les droits de douane, vous pourrez demander le remboursement de la différence en crédit Faire une fois la commande livrée."
    }]
  });
};
var YOU_WILL_BE_RESPONSIBLE_FOR_DUTIES = function YOU_WILL_BE_RESPONSIBLE_FOR_DUTIES(strictLocalize) {
  return strictLocalize({
    id: "XjOUVq",
    defaultMessage: [{
      "type": 0,
      "value": "Si les droits de douane ne sont pas pris en charge pour votre commande, vous devrez vous en acquitter."
    }]
  });
};
var ORDER_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION = function ORDER_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize) {
  return strictLocalize({
    id: "C5Am+H",
    defaultMessage: [{
      "type": 0,
      "value": "Les droits de douane sont pris en charge sur cette commande. Une facture pour les droits de douane est créée dès qu'une commande inclut des produits sur lesquels des droits de douane s'appliquent. Puisque les droits de douane sont pris en charge pour votre commande, nous appliquerons lors du passage en caisse une remise correspondant au coût estimé des droits de douane pour votre commande. À l'expédition de la commande, le transporteur vous enverra une facture incluant tous les frais (y compris les droits de douane et la TVA), que vous paierez en totalité. Si le coût réel des droits de douane et des frais de débours est supérieur à la remise appliquée pour les droits de douane, vous pourrez demander le remboursement de la différence en crédit Faire une fois la commande livrée."
    }]
  });
};
var ORDER_NOT_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION = function ORDER_NOT_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize) {
  return strictLocalize({
    id: "0Ut9wH",
    defaultMessage: [{
      "type": 0,
      "value": "Les droits de douane ne peuvent pas être pris en charge sur cette commande. Une facture pour les droits de douane est créée dès qu'une commande inclut des produits sur lesquels des droits de douane s'appliquent. Les droits de douane n'étant pas pris en charge sur votre commande, vous devrez vous en acquitter. À l'expédition de la commande, le transporteur vous enverra une facture incluant tous les frais (y compris les droits de douane et la TVA), que vous paierez en totalité."
    }]
  });
};